import { ButtonGroup } from "data/CellComponent";
import {
  Instruction,
  ProgramContentType,
  InstructionWithContent,
  InstructionWithTextarea,
} from "../BlockComponent";

export const Content_0_3_A = (isFirst: boolean) => [
  Instruction("typography_0_0_0"),
  InstructionWithTextarea(`typography_1_0_0`, { id: "satisfiedPart" }),
  InstructionWithTextarea(`typography_2_0_0`, { id: "unsatisfiedPart" }),
  InstructionWithTextarea(`typography_3_0_0`, { id: "suggestion" }),
  InstructionWithContent("typography_4_0_0", [
    [
      ButtonGroup(
        [
          {
            translationKey: "매우 아쉬울 것 같아요",
            ...(isFirst && { showFromId: "리뷰 요청" }),
          },
          {
            translationKey: "조금 아쉬울 것 같아요",
            ...(isFirst && { hideFromId: "리뷰 요청", showFromId: "마무리" }),
          },
          {
            translationKey: "전혀 아쉽지 않을 것 같아요",
            ...(isFirst && { hideFromId: "리뷰 요청", showFromId: "마무리" }),
          },
          {
            translationKey: "지금은 사용하고 있지 않아 해당 사항이 없어요",
            ...(isFirst && { hideFromId: "리뷰 요청", showFromId: "마무리" }),
          },
        ],
        { id: "feelingWhenTermination" }
      ),
    ],
  ]),
  ...(isFirst
    ? [
        InstructionWithContent(
          "typography_6_0_0",
          [[{ type: "storeReview", content: {} }]],
          { blockId: "리뷰 요청" }
        ),
      ]
    : []),

  Instruction("typography_5_0_0", { blockId: "마무리" }),
];
